import { Button, Typography } from '@mui/material';
import { useMemo, useState } from 'react';
import ModalV2 from '/@/components/bayer/modal-v2';
import SelectCheckbox from '/@/components/bayer/select-checkbox';
import { useValidatedUsersRvs } from '/@/hooks/nodes';
import { _ } from '/@/locale';
import { modalBodyPropsWide, modalProps } from '.';

const RVOnboardingModalRVSelector = ({
    open,
    onClose,
    onNext,
    isSending = false,
}: {
    open: boolean;
    onClose: () => void;
    onNext: (rv: number) => void;
    isSending?: boolean;
}) => {
    const [selectedRv, setSelectedRv] = useState<number | null>(null);
    const rvQuery = useValidatedUsersRvs({});

    const rvItems = useMemo(() => {
        return (rvQuery.data?.results || []).map((rv, index) => {
            const name = [rv.firstName, rv.lastName].filter(Boolean).join(' ') || rv.email || '';
            const userNodeId = rv.userNode?.id;
            return {
                id: userNodeId ?? -(index + 1),
                label: name,
                disabled: !userNodeId ? _('Usuario no disponible') : undefined,
            };
        });
    }, [rvQuery.data?.results]);
    return (
        <ModalV2
            open={open}
            onClose={onClose}
            title={_('Seleccioná a tu RV para enviarle una solicitud de vinculación')}
            actions={
                <Button
                    variant='contained'
                    color='secondary'
                    onClick={() => {
                        if (selectedRv) {
                            onNext(selectedRv);
                        }
                    }}
                    disabled={!selectedRv || isSending}
                >
                    {isSending ? _('Enviando...') : _('Enviar solicitud de vinculación')}
                </Button>
            }
            {...modalProps}
            bodyProps={{
                ...modalProps.bodyProps,
                ...modalBodyPropsWide,
            }}
        >
            <Typography variant='body1' color='primary'>
                {_(
                    'Cuando acepte la solicitud, ambos van a ver y trabajar con la información de los productores Premium que comparten.'
                )}
            </Typography>
            <SelectCheckbox
                selectedItem={selectedRv}
                setSelectedItem={setSelectedRv}
                InputProps={{
                    placeholder: _('Buscar nombre o apellido y seleccioná una opción de la lista'),
                }}
                items={rvItems}
                verbose={_('RV')}
                loading={rvQuery.isLoading}
            />
        </ModalV2>
    );
};

export default RVOnboardingModalRVSelector;
